import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Dados que permanecem até ser atualizado
// Não estando no dataState a store é limpa após refresh
const dataState = createPersistedState({
  paths: ['user', 'pedidoAberto'],
})

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    user: {},
    produtosMultiplosPedidos: [],
    listaMultiplosPedidos: [],
    pedidoInfo: {},
    pedidoAberto: {},

    hiperfarmaPedidoUsuario: {},
  },
  plugins: [dataState],
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setUser(state, payload) {
      state.user = payload.value
    },
    setPedidoAberto(state, payload) {
      state.pedidoAberto = payload.value
    },
    setProdutosMultiplosPedidos(state, payload) {
      state.produtosMultiplosPedidos = payload.value
    },
    setMultiplosPedidos(state, payload) {
      state.listaMultiplosPedidos = payload.value
    },
    setPedidoInfo(state, payload) {
      state.pedidoInfo = payload.value
    },

    setHiperfarmaPedidoUsuario(state, payload) {
      state.hiperfarmaPedidoUsuario = payload.value
    },
  },
  getters: {
    user(state) {
      return state.user
    },
    produtosMultiplosPedidos(state) {
      return state.produtosMultiplosPedidos
    },
    multiplosPedidos(state) {
      return state.listaMultiplosPedidos
    },
    pedidoInfo(state) {
      return state.pedidoInfo
    },

    hiperfarmaPedidoUsuario(state) {
      return state.hiperfarmaPedidoUsuario
    },
  },
  actions: {},
  modules: {},
})
